<header class="app-header">
  <!-- Branding. Replace the inline mark with the official Hudson logo asset when available. -->
  <!-- routerLink (not href) so navigating home stays a SPA route and doesn't reload the
       app — a full reload would recreate services and wipe in-memory notifications. -->
  <a class="brand" routerLink="/" aria-label="Hudson Crop &amp; Livestock — home">
    <span class="brand__mark" aria-hidden="true">
      <svg viewBox="0 0 32 32" width="30" height="30">
        <circle cx="16" cy="16" r="15" fill="#ffffff" />
        <path d="M16 6.5c5.2 2 8.4 5.2 8.4 10.2 0 3.2-2.1 6-6.2 7.1.1-5.1-3-8.3-7.3-9.4 3.1 0 5.3 1 6.4 3.1.1-4.2-1-8.1-1.3-11z"
              fill="#195C7D" />
      </svg>
    </span>
    <span class="brand__text">
      <span class="brand__t1">Hudson</span>
      <span class="brand__t2">Crop &amp; Livestock</span>
    </span>
  </a>

  @if (environmentLabel) {
    <span class="env-badge" [attr.data-env]="environmentLabel">{{ environmentLabel }}</span>
  }

  <span class="header__spacer"></span>

  <nav class="header__tools" aria-label="Global actions">
    <div class="header__search" [class.header__search--open]="searchOpen">
      @if (searchOpen) {
        <p-autoComplete
          class="header__search-input"
          [(ngModel)]="searchQuery"
          [suggestions]="searchSuggestions"
          (completeMethod)="onSearchComplete($event)"
          (onSelect)="onReportSelected($event)"
          optionLabel="title"
          [minLength]="1"
          [delay]="150"
          [autofocus]="true"
          appendTo="body"
          panelStyleClass="report-search-panel"
          placeholder="Search reports…"
          ariaLabel="Search reports">
          <ng-template let-report pTemplate="item">
            <div class="search-item">
              <span class="search-item__title">{{ report.title }}</span>
              <span class="search-item__division">{{ report.divisionLabel }}</span>
            </div>
          </ng-template>
        </p-autoComplete>
      }
      <button type="button" class="icon-btn" [attr.aria-label]="searchOpen ? 'Close search' : 'Search'"
              [attr.aria-expanded]="searchOpen" (click)="toggleSearch()">
        <i class="pi" [class.pi-search]="!searchOpen" [class.pi-times]="searchOpen" aria-hidden="true"></i>
      </button>
    </div>

    <button type="button" class="icon-btn" aria-label="Notifications"
            (click)="onBellClick(); notifPanel.toggle($event)">
      <i class="pi pi-bell" aria-hidden="true"></i>
      @if (notifications.count() > 0) {
        <span class="icon-btn__badge">{{ notifications.count() > 99 ? '99+' : notifications.count() }}</span>
      }
    </button>

    <button type="button" class="icon-btn" aria-label="Applications"
            (click)="appsPanel.toggle($event)">
      <i class="pi pi-th-large" aria-hidden="true"></i>
    </button>

    <!-- Account button: PrimeNG rounded + outlined look (Figma) -->
    <button type="button" class="user-btn" aria-label="Account menu"
            (click)="accountMenu.toggle($event)">
      <span class="user-btn__avatar"><i class="pi pi-user" aria-hidden="true"></i></span>
      <span class="user-btn__name">{{ username }}</span>
      <i class="pi pi-chevron-down user-btn__caret" aria-hidden="true"></i>
    </button>
  </nav>

  <!-- Notifications -->
  <p-popover #notifPanel appendTo="body" styleClass="header-notif-popover">
    <div class="notif">
      <div class="notif__head">
        <span class="notif__heading">Notifications</span>
        @if (notifications.notifications().length > 0) {
          <button type="button" class="notif__clear" (click)="notifications.clear()">Clear all</button>
        }
      </div>
      @if (notifications.notifications().length === 0) {
        <p class="notif__empty">You have no notifications yet.</p>
      } @else {
        <ul class="notif__list">
          @for (n of notifications.notifications(); track n.id) {
            <li class="notif__item notif__item--{{ n.severity }}">
              <i class="pi notif__icon" [ngClass]="iconFor(n.severity)" aria-hidden="true"></i>
              <div class="notif__body">
                <span class="notif__title">{{ n.summary }}</span>
                <span class="notif__detail">{{ n.detail }}</span>
                <span class="notif__time">{{ n.timestamp | date: 'MMM d, h:mm a' }}</span>
              </div>
            </li>
          }
        </ul>
      }
    </div>
  </p-popover>

  <!-- Apps launcher -->
  <p-popover #appsPanel appendTo="body" styleClass="header-apps-popover">
    <div class="apps-grid">
      @for (app of apps; track app.label) {
        <a class="apps-grid__tile" [href]="app.url" [style.--tile]="app.color">
          <span class="apps-grid__icon"><i [class]="app.icon" aria-hidden="true"></i></span>
          <span class="apps-grid__label">{{ app.label }}</span>
        </a>
      }
    </div>
  </p-popover>

  <!-- Account menu: Profile / Calendar / Log out -->
  <p-menu #accountMenu [model]="userMenuItems" [popup]="true" appendTo="body"></p-menu>
</header>
